import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab, Box, Typography, Paper } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import PageHeader from '../../../components/PageHeader/PageHeader';
import CustomTabPanel from '../../../components/Tab/CustomTabPanel';
import { permissionOptions } from '../../../utils/Enums';
import ObjectivesTable from '../../../components/Objectives/ObjectivesTable';
import AchievementsTable from '../../../components/Achievements/AchievementsTable';

const ObjectivesPage = () => {
    const { t } = useTranslation();
    const [tabValue, setTabValue] = useState(0);

    const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
    const hasPermission = (permissionId) => userPermissions.includes(permissionId);
    const hasManageObjectives = hasPermission(permissionOptions.find(p => p.label === 'MANAGE_OBJECTIVES')?.id);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    if (!hasManageObjectives) {
        return (
            <Box p={3}>
                <PageHeader 
                    title={t('objectives') || 'Objetivos'} 
                    subtitle={t('objectives_header') || 'Administra objetivos y logros'} 
                />
                <Paper sx={{ p: 6, mt: 4, textAlign: 'center' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <LockIcon sx={{ fontSize: 80, color: 'text.secondary', opacity: 0.5 }} />
                        <Typography variant="h5" gutterBottom>
                            {t('no_permission') || 'Sin permisos'}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500 }}>
                            {t('no_manage_objectives_permission') || 'No tienes permiso para administrar objetivos y logros. Contacta a tu administrador para obtener acceso.'}
                        </Typography>
                    </Box>
                </Paper>
            </Box>
        );
    }

    return (
        <div>            
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleChangeTab} aria-label="objectives tabs">
                    <Tab label={t('objectives') || 'Objetivos'} />
                    <Tab label={t('achievements') || 'Logros'} />
                </Tabs>
            </Box>

            <CustomTabPanel value={tabValue} index={0}>
                <PageHeader 
                    title={t('objectives') || 'Objetivos'} 
                    subtitle={t('objectives_header') || 'Administra objetivos y logros'} 
                />
                <ObjectivesTable />
            </CustomTabPanel>

            <CustomTabPanel value={tabValue} index={1}>
                <PageHeader 
                    title={t('achievements') || 'Logros'} 
                    subtitle={t('achievements_headaer') || 'Administra los logros disponibles en el sistema'} 
                />
                <AchievementsTable />
            </CustomTabPanel>
        </div>
    );
};

export default React.memo(ObjectivesPage);
